import { Controller } from '@hotwired/stimulus'

// Lock broadcasts die with a backgrounded tab: Safari suspends the page and
// its cable connection, and missed Turbo Stream messages are never replayed.
// When the tab wakes, refetch the page and swap any lock wrapper whose state
// changed — untouched ones are left alone so a half-typed answer survives.
export default class extends Controller {
  static values = { minHiddenSeconds: { type: Number, default: 5 } }

  connect() {
    this.refresh = this.refresh.bind(this)
    document.addEventListener('visibilitychange', this.refresh)
  }

  disconnect() {
    document.removeEventListener('visibilitychange', this.refresh)
  }

  async refresh() {
    if (document.visibilityState !== 'visible') {
      this.hiddenAt = Date.now()
      return
    }

    // A quick alt-tab never suspends the cable; only a real absence warrants
    // refetching the page.
    if (this.hiddenAt && Date.now() - this.hiddenAt < this.minHiddenSecondsValue * 1000) return

    const response = await fetch(location.href, { headers: { Accept: 'text/html' } })
    if (!response.ok) return

    const fresh = new DOMParser().parseFromString(await response.text(), 'text/html')

    this.element.querySelectorAll('div[id$="_lock"]').forEach((current) => {
      const next = fresh.getElementById(current.id)
      if (next && this.state(next) !== this.state(current)) {
        current.replaceChildren(...next.children)
      }
    })
  }

  // A question wrapper holds a form when unlocked; a spark wrapper holds the
  // overlay when locked and nothing when open.
  state(wrapper) {
    if (wrapper.querySelector('form')) return 'form'

    return wrapper.children.length ? 'locked' : 'open'
  }
}
